// MaxDriver review form: posts JSON to the first-party reviews backend.
// Magic-link params from the review-request emails (?recenzie=<token>&stele=<n>)
// auto-open the form, prefill name/email/sku via GET /magic and preselect stars.
(() => {
  const root = document.querySelector('[data-md-review-form]');
  if (!root) return;

  const api = root.dataset.api;
  let sku = root.dataset.sku || '';
  const openBtn = root.querySelector('[data-md-rf-open]');
  const form = root.querySelector('[data-md-rf-form]');
  const success = root.querySelector('[data-md-rf-success]');
  const errorEl = root.querySelector('[data-md-rf-error]');
  const submitBtn = root.querySelector('[data-md-rf-submit]');

  openBtn.hidden = false;
  openBtn.addEventListener('click', () => {
    form.hidden = false;
    openBtn.hidden = true;
    form.querySelector('textarea[name="body"]')?.focus();
  });

  // cap the use-case checkboxes at 3 (backend truncates anyway; keep UI honest)
  const ucWrap = root.querySelector('[data-md-rf-usecases]');
  ucWrap?.addEventListener('change', () => {
    const boxes = [...ucWrap.querySelectorAll('input[type="checkbox"]')];
    const checked = boxes.filter((b) => b.checked).length;
    boxes.forEach((b) => { if (!b.checked) b.disabled = checked >= 3; });
  });

  // magic-link prefill
  const params = new URLSearchParams(location.search);
  const rawToken = params.get('recenzie');
  const token = rawToken && /^[a-f0-9]{36}$/.test(rawToken) ? rawToken : null;
  const stars = Number(params.get('stele'));
  if (stars >= 1 && stars <= 5) {
    const star = form.querySelector(`input[name="rating"][value="${stars}"]`);
    if (star) star.checked = true;
  }
  if (token) {
    openBtn.hidden = true;
    form.hidden = false;
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    fetch(`${api}/magic?t=${token}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!d) return;
        if (d.name) form.querySelector('input[name="name"]').value = d.name;
        if (d.email) form.querySelector('input[name="email"]').value = d.email;
        if (d.sku) sku = d.sku;
      })
      .catch(() => {});
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!form.reportValidity()) return;
    errorEl.hidden = true;
    submitBtn.disabled = true;

    const fd = new FormData(form);
    const body = {
      sku,
      rating: Number(fd.get('rating')),
      title: fd.get('title') || undefined,
      body: fd.get('body'),
      name: fd.get('name'),
      email: fd.get('email'),
      car_model: fd.get('car_model') || undefined,
      use_cases: fd.getAll('use_cases'),
      install_ease: fd.get('install_ease') ? Number(fd.get('install_ease')) : undefined,
      recommend: fd.get('recommend') === null ? undefined : fd.get('recommend') === 'true',
      magic: token || undefined,
      website: fd.get('website') || undefined,
    };

    try {
      const res = await fetch(`${api}/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error('submit');
      form.hidden = true;
      success.hidden = false;
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch {
      errorEl.hidden = false;
      submitBtn.disabled = false;
    }
  });
})();
